import React, { Fragment }from 'react';
import { connect } from 'react-redux';

import PrevNext from '../prevAndNext/PrevNext';
import CommonOrderTable from '../common/orders/CommonOrderTable';
import CommonOrderDateTimeDock from '../common/orders/CommonOrderDateTimeDock';
import CommonOrderTopTextFields from '../common/orders/CommonOrderTopTextFields';
import DockerOverloadModalContainer from '../dockOverloadModal/DockerOverloadModalContainer';
import CommonOrderTruckerInformation from '../common/orders/CommonOrderTruckerInformation';
import CommonOrderAdditionalInformation from '../common/orders/CommonOrderAdditionalInformation';
import CommonOrderTruckingInfoWrapper from '../common/orders/CommonOrderTruckingInfoWrapper';
import ManualEntryOrderDriverInfo from '../common/orders/ManualEntryOrderDriverInfo';

import style from '../common/orders/ordersStyle.module.css';
import commonStyles from '../common/common.module.css';

import { Button  } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import User, { UserRoleType } from '../../models/User';
import PickupOrderModel from '../../models/PickupOrder';

import { Moment } from 'moment';

const styles = (theme: Theme) =>

  createStyles({
    btnWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '30px'
    },
    update: {
      width: '200px',
    },
    link: {
      textDecoration: 'none'
    }
  });

interface DropOffOrderProps {
  classes: any;
  dropOffOrder: PickupOrderModel;
  user: User;
  initialDeliveryCompanyID: number | undefined;
  showDetails: boolean;
  showTruckerInfo?: boolean;
  showNotify: boolean;
  selectedDeliveryCompanyID: number | undefined;
  openDockOverloadModal: boolean;
  dropOffDate: Moment | string;
  cutOffDate: Moment | string;
  cutoffTime: Moment;
  backToList?: boolean;
  editErrors: { pieces: { error: boolean, message: string }, weight: { error: boolean, message: string } };
  handleSelectPickUpTime: () => void;
  pickupDateChange: (type: string, date: Moment) => void;
  handleFieldsInput: (fieldName: string, event: any) => void;
  setContainerState: (data: any) => void;
  hideTruckerInfo: () => void;
  resetPickupTime: () => void;
  handleSetDeliveryCompanyID: (deliveryCompanyID: number) => void;
  changedDeliveryCompany: (newDeliveryCompanyID: number) => void;
  setDriverID: Function;
  selectedDriverID: number | undefined;
  changedDriver: Function;
  initialDriverID: number | undefined;
  changeDriverDetails: Function;
  submitPickupOrder: () => void;
  handleCloseDockOverloadModal: (time: string) => void;
  changeInputCutOffTime: (event: any) => void;
  lastAwbDeletionWarning: ((callback: () => void) => void);
  showLine: boolean;
  sendOrder: string;
  handleChangeSendOrder: (event: any) => void;
  userRole: UserRoleType;
  isMeEditMode: boolean;
  handleClick: Function;
  maskOn: Function;
  deleteLastAwb: boolean;
};
  
  const dropOffOrder = (props: DropOffOrderProps) => {

    const prevButtonHref: string = (!props.userRole || props.userRole === UserRoleType.FORWARDER) ? '/truck' : (props.isMeEditMode ? 'manual-entry-export' : '/manual-entry-truck');
      return (
        <div className={ style.orderWrapper }>
          <div className= { commonStyles.headerDummyDiv }> </div>
      
          { props.showLine && 
          
            <div className={ style.firstHorizontalLine } />
          }

          { !props.showLine && 
            
            <div className={ style.marginTop } />
          } 

          <CommonOrderDateTimeDock
            pickupOrder={ props.dropOffOrder }
            handleSelectPickUpTime={ props.handleSelectPickUpTime }
            pickupDate={ props.dropOffDate }
            pickupDateChange={ props.pickupDateChange }
            cutoffDate={ props.cutOffDate }
            cutoffTime={ props.cutoffTime }
            userRole={ props.userRole }
            changeInputCutOffTime={ props.changeInputCutOffTime }
            type='do'
          /> 

          <div className={ `${ commonStyles.wrapper } ${ style.wrapper }` }>
            <h3 className={ `${ commonStyles.header }` }>Additional Information</h3>
            <CommonOrderTopTextFields
              pickupOrder={ props.dropOffOrder }
              handleFieldsInput={ props.handleFieldsInput }
              type={ 'do' }
              userRole={ ''}
            />

            { (!props.userRole || props.userRole === UserRoleType.FORWARDER) &&

              <CommonOrderAdditionalInformation
                pickupOrder={ props.dropOffOrder }
                handleFieldsInput={ props.handleFieldsInput }
                type={ 'do' }
              />
            }
          </div>

          { props.userRole === UserRoleType.GHA &&
            <ManualEntryOrderDriverInfo pickupOrder={ props.dropOffOrder }/>
          }

          <CommonOrderTable 
            pickupOrder={ props.dropOffOrder } 
            setState={ props.setContainerState }
            editErrors={ props.editErrors }
            type={ 'do' }
            lastAwbDeletionWarning={ props.lastAwbDeletionWarning }
          />

          { (!props.userRole || props.userRole === UserRoleType.FORWARDER) &&
            <Fragment>
              <CommonOrderTruckingInfoWrapper
                selectedDeliveryCompanyID={ props.showDetails ? props.selectedDeliveryCompanyID : props.dropOffOrder.id_delivery_company || undefined }
                setDeliveryCompanyID={ props.handleSetDeliveryCompanyID }
                showDetails={ props.showDetails }
                setDriverID= { props.setDriverID }
                selectedDriverID= { props.selectedDriverID }
                changedDriver= { props.changedDriver }
                initialDriverID= { props.initialDriverID }
                hideTruckerInfo={ props.hideTruckerInfo }
                changeDriverDetails={ props.changeDriverDetails }
                resetPickupTime={ props.resetPickupTime }
                changedDeliveryCompany={ props.changedDeliveryCompany }
                initialDeliveryCompanyID={ props.initialDeliveryCompanyID }
                order={ props.dropOffOrder }
                sendOrder={ props.sendOrder }
                handleChangeSendOrder={ props.handleChangeSendOrder } 
                submitPickupOrder={props.submitPickupOrder}
                handleClick={ props.handleClick }
                maskOn={ props.maskOn }
              />

              { props.showTruckerInfo && props.dropOffOrder.id_delivery_company &&
                <CommonOrderTruckerInformation
                  pickupOrder={ props.dropOffOrder }
                  type={ 'do' }
                />
              }
            </Fragment>
          }
    
          { props.openDockOverloadModal &&
            <DockerOverloadModalContainer 
              openDockOverloadModal={ props.openDockOverloadModal }
              handleCloseDockOverloadModal={ props.handleCloseDockOverloadModal }
              forInfo={ false }
              ghaID={ props.dropOffOrder.id_gha }
              type={ 'export'}
              date={ props.dropOffOrder.pickup_date }
              time= { props.dropOffOrder.pickup_time }
            />
          }
          
          { props.userRole === UserRoleType.GHA &&
            <div className={ props.classes.btnWrapper}>
              <Link to={{  pathname: '/manage-exports', state: { orderNumber: props.deleteLastAwb ? '' : props.dropOffOrder.number, orderType: 'do'}  }}className={props.classes.link}><Button className={ props.classes.return }  color="primary" variant="contained">Go To Manage Export</Button></Link>
              <Button className={ props.classes.update } onClick={ props.submitPickupOrder } color="primary" variant="contained" >Update</Button>
            </div>
          }

          { props.backToList
            ? <PrevNext prevButton={ { active: true, href: '/my-drop-off-orders', animate: true } } />
            : <PrevNext prevButton={ { active: true, href: `${prevButtonHref}`, animate: true } } />
          }

        </div>
      )
  }

const mapStateToProps = (state: any) => {
  return {
    isMeEditMode: state.manualEntryEdit.isEditMode
  }
}
  
export default withStyles(styles)(connect(mapStateToProps, {})(dropOffOrder));
